import { useSyncExternalStore } from "react"

const QUERY = "(prefers-reduced-motion: reduce)"

const getSnapshot = () => {
  // Guard against SSR and JSDOM
  if (typeof window === "undefined" || !window.matchMedia) {
    return false
  }
  return window.matchMedia(QUERY).matches
}

const subscribe = (callback: () => void) => {
  // Guard against SSR and JSDOM
  if (typeof window === "undefined" || !window.matchMedia) {
    return () => {}
  }

  const mediaQuery = window.matchMedia(QUERY)

  // Support both modern addEventListener and legacy addListener
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener("change", callback)
    return () => mediaQuery.removeEventListener("change", callback)
  } else if (mediaQuery.addListener) {
    // Fallback for older browsers and test environments
    mediaQuery.addListener(callback)
    return () => mediaQuery.removeListener(callback)
  }

  return () => {}
}

const getServerSnapshot = () => false

export const useReducedMotion = () => {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
